import { useQuery } from 'react-query';
import { useMemo } from 'react';
import { getRegisterResultReviews } from 'apis/registerResult';

const useGetRegisterResultReviews = (registerResultId, conds = {}) => {
  const { data: _data, ...rest } = useQuery(
    ['getRegisterResultReviews', registerResultId],
    () => getRegisterResultReviews(registerResultId),
    {
      ...conds,
    }
  );

  const data = useMemo(() => _data?.data ?? [], [_data]);

  return {
    data,
    ...rest,
  };
};

export default useGetRegisterResultReviews;
